export default __webpack_public_path__ + "static/m3-collapsible-fab-behavior-1fb3680be653b2f30f609e8ad227488c.mp4";